var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaretDownOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    transform: "rotate(180 0 0)",
    viewBox: "0 0 9 5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.5,10 C7.33864542,10 7.17729084,9.93982919 7.05378486,9.81948758 L3.18525896,6.05007764 C2.93824701,5.80939441 2.93824701,5.42119565 3.18525896,5.18051242 C3.43227092,4.93982919 3.83067729,4.93982919 4.07569721,5.18051242 L7.5,8.51708075 L10.9243028,5.18051242 C11.1713147,4.93982919 11.5697211,4.93982919 11.814741,5.18051242 C12.061753,5.42119565 12.061753,5.80939441 11.814741,6.05007764 L7.94621514,9.81948758 C7.82270916,9.93982919 7.66135458,10 7.5,10 Z",
    id: "truc-arrow-down-outlined"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Requests---Listing---Table",
    transform: "translate(-296.000000, -165.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(293.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#truc-arrow-down-outlined"
  })), /*#__PURE__*/React.createElement("use", {
    id: "arrow-up",
    fillRule: "nonzero",
    transform: "translate(7.500000, 7.500000) rotate(-180.000000) translate(-7.500000, -7.500000) ",
    xlinkHref: "#truc-arrow-down-outlined"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDownOutlined);
export default ForwardRef;